import { Box, Image, Link, LinkProps, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';

import styles from './AddToCalendar.module.scss';
import { getDataTracking } from '../../utils';

export interface CalendarLinkProps extends LinkProps {
  name?: string;
  imgSrc?: string;
}

export const CalendarLink: FC<CalendarLinkProps> = ({
  href,
  imgSrc,
  name,
  onClick,
  ...rest
}) => (
  <Link
    isExternal
    className={styles.calendarLink}
    href={href}
    onClick={onClick}
    {...rest}
    {...getDataTracking(`${name}Link`)}
  >
    <Box w="115px" h="110px">
      <VStack>
        <Image maxW="48px" maxH="48px" src={imgSrc} />
        <Text align="center" fontWeight="normal">
          {name}
        </Text>
      </VStack>
    </Box>
  </Link>
);
